/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDrink = /* GraphQL */ `
  mutation CreateDrink(
    $input: CreateDrinkInput!
    $condition: ModelDrinkConditionInput
  ) {
    createDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      createdAt
      updatedAt
    }
  }
`;
export const updateDrink = /* GraphQL */ `
  mutation UpdateDrink(
    $input: UpdateDrinkInput!
    $condition: ModelDrinkConditionInput
  ) {
    updateDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      createdAt
      updatedAt
    }
  }
`;
export const deleteDrink = /* GraphQL */ `
  mutation DeleteDrink(
    $input: DeleteDrinkInput!
    $condition: ModelDrinkConditionInput
  ) {
    deleteDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      createdAt
      updatedAt
    }
  }
`;
export const createGameDrink = /* GraphQL */ `
  mutation CreateGameDrink(
    $input: CreateGameDrinkInput!
    $condition: ModelGameDrinkConditionInput
  ) {
    createGameDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      round
      createdAt
      updatedAt
    }
  }
`;
export const updateGameDrink = /* GraphQL */ `
  mutation UpdateGameDrink(
    $input: UpdateGameDrinkInput!
    $condition: ModelGameDrinkConditionInput
  ) {
    updateGameDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      round
      createdAt
      updatedAt
    }
  }
`;
export const deleteGameDrink = /* GraphQL */ `
  mutation DeleteGameDrink(
    $input: DeleteGameDrinkInput!
    $condition: ModelGameDrinkConditionInput
  ) {
    deleteGameDrink(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      value
      status
      wildAction
      deathAction
      round
      createdAt
      updatedAt
    }
  }
`;
export const createAction = /* GraphQL */ `
  mutation CreateAction(
    $input: CreateActionInput!
    $condition: ModelActionConditionInput
  ) {
    createAction(input: $input, condition: $condition) {
      id
      title
      description
      drinkPoints
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateAction = /* GraphQL */ `
  mutation UpdateAction(
    $input: UpdateActionInput!
    $condition: ModelActionConditionInput
  ) {
    updateAction(input: $input, condition: $condition) {
      id
      title
      description
      drinkPoints
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteAction = /* GraphQL */ `
  mutation DeleteAction(
    $input: DeleteActionInput!
    $condition: ModelActionConditionInput
  ) {
    deleteAction(input: $input, condition: $condition) {
      id
      title
      description
      drinkPoints
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const createDeath = /* GraphQL */ `
  mutation CreateDeath(
    $input: CreateDeathInput!
    $condition: ModelDeathConditionInput
  ) {
    createDeath(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateDeath = /* GraphQL */ `
  mutation UpdateDeath(
    $input: UpdateDeathInput!
    $condition: ModelDeathConditionInput
  ) {
    updateDeath(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteDeath = /* GraphQL */ `
  mutation DeleteDeath(
    $input: DeleteDeathInput!
    $condition: ModelDeathConditionInput
  ) {
    deleteDeath(input: $input, condition: $condition) {
      id
      title
      description
      filePath
      status
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      name
      alias
      drink
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      name
      alias
      drink
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      name
      alias
      drink
      createdAt
      updatedAt
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam(
    $input: CreateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    createTeam(input: $input, condition: $condition) {
      id
      name
      searchTerm
      score
      round
      users
      drinkList
      gameDrinks
      d1title
      d1description
      d1filePath
      d1value
      d1status
      d1DeathStatus
      d1DeathTitle
      d1DeathFilePath
      d1DeathDescription
      d2title
      d2description
      d2filePath
      d2value
      d2status
      d2DeathStatus
      d2DeathTitle
      d2DeathFilePath
      d2DeathDescription
      d3title
      d3description
      d3filePath
      d3value
      d3status
      d3DeathStatus
      d3DeathTitle
      d3DeathFilePath
      d3DeathDescription
      d4title
      d4description
      d4filePath
      d4value
      d4status
      d4DeathStatus
      d4DeathTitle
      d4DeathFilePath
      d4DeathDescription
      wildNames
      wildDescription
      wildImage
      wildState
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    updateTeam(input: $input, condition: $condition) {
      id
      name
      searchTerm
      score
      round
      users
      drinkList
      gameDrinks
      d1title
      d1description
      d1filePath
      d1value
      d1status
      d1DeathStatus
      d1DeathTitle
      d1DeathFilePath
      d1DeathDescription
      d2title
      d2description
      d2filePath
      d2value
      d2status
      d2DeathStatus
      d2DeathTitle
      d2DeathFilePath
      d2DeathDescription
      d3title
      d3description
      d3filePath
      d3value
      d3status
      d3DeathStatus
      d3DeathTitle
      d3DeathFilePath
      d3DeathDescription
      d4title
      d4description
      d4filePath
      d4value
      d4status
      d4DeathStatus
      d4DeathTitle
      d4DeathFilePath
      d4DeathDescription
      wildNames
      wildDescription
      wildImage
      wildState
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam(
    $input: DeleteTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    deleteTeam(input: $input, condition: $condition) {
      id
      name
      searchTerm
      score
      round
      users
      drinkList
      gameDrinks
      d1title
      d1description
      d1filePath
      d1value
      d1status
      d1DeathStatus
      d1DeathTitle
      d1DeathFilePath
      d1DeathDescription
      d2title
      d2description
      d2filePath
      d2value
      d2status
      d2DeathStatus
      d2DeathTitle
      d2DeathFilePath
      d2DeathDescription
      d3title
      d3description
      d3filePath
      d3value
      d3status
      d3DeathStatus
      d3DeathTitle
      d3DeathFilePath
      d3DeathDescription
      d4title
      d4description
      d4filePath
      d4value
      d4status
      d4DeathStatus
      d4DeathTitle
      d4DeathFilePath
      d4DeathDescription
      wildNames
      wildDescription
      wildImage
      wildState
      status
      createdAt
      updatedAt
    }
  }
`;
export const createParty = /* GraphQL */ `
  mutation CreateParty(
    $input: CreatePartyInput!
    $condition: ModelPartyConditionInput
  ) {
    createParty(input: $input, condition: $condition) {
      id
      name
      teams {
        id
        name
        searchTerm
        score
        round
        users
        drinkList
        gameDrinks
        d1title
        d1description
        d1filePath
        d1value
        d1status
        d1DeathStatus
        d1DeathTitle
        d1DeathFilePath
        d1DeathDescription
        d2title
        d2description
        d2filePath
        d2value
        d2status
        d2DeathStatus
        d2DeathTitle
        d2DeathFilePath
        d2DeathDescription
        d3title
        d3description
        d3filePath
        d3value
        d3status
        d3DeathStatus
        d3DeathTitle
        d3DeathFilePath
        d3DeathDescription
        d4title
        d4description
        d4filePath
        d4value
        d4status
        d4DeathStatus
        d4DeathTitle
        d4DeathFilePath
        d4DeathDescription
        wildNames
        wildDescription
        wildImage
        wildState
        status
        createdAt
        updatedAt
      }
      round
      createdAt
      updatedAt
    }
  }
`;
export const updateParty = /* GraphQL */ `
  mutation UpdateParty(
    $input: UpdatePartyInput!
    $condition: ModelPartyConditionInput
  ) {
    updateParty(input: $input, condition: $condition) {
      id
      name
      teams {
        id
        name
        searchTerm
        score
        round
        users
        drinkList
        gameDrinks
        d1title
        d1description
        d1filePath
        d1value
        d1status
        d1DeathStatus
        d1DeathTitle
        d1DeathFilePath
        d1DeathDescription
        d2title
        d2description
        d2filePath
        d2value
        d2status
        d2DeathStatus
        d2DeathTitle
        d2DeathFilePath
        d2DeathDescription
        d3title
        d3description
        d3filePath
        d3value
        d3status
        d3DeathStatus
        d3DeathTitle
        d3DeathFilePath
        d3DeathDescription
        d4title
        d4description
        d4filePath
        d4value
        d4status
        d4DeathStatus
        d4DeathTitle
        d4DeathFilePath
        d4DeathDescription
        wildNames
        wildDescription
        wildImage
        wildState
        status
        createdAt
        updatedAt
      }
      round
      createdAt
      updatedAt
    }
  }
`;
export const deleteParty = /* GraphQL */ `
  mutation DeleteParty(
    $input: DeletePartyInput!
    $condition: ModelPartyConditionInput
  ) {
    deleteParty(input: $input, condition: $condition) {
      id
      name
      teams {
        id
        name
        searchTerm
        score
        round
        users
        drinkList
        gameDrinks
        d1title
        d1description
        d1filePath
        d1value
        d1status
        d1DeathStatus
        d1DeathTitle
        d1DeathFilePath
        d1DeathDescription
        d2title
        d2description
        d2filePath
        d2value
        d2status
        d2DeathStatus
        d2DeathTitle
        d2DeathFilePath
        d2DeathDescription
        d3title
        d3description
        d3filePath
        d3value
        d3status
        d3DeathStatus
        d3DeathTitle
        d3DeathFilePath
        d3DeathDescription
        d4title
        d4description
        d4filePath
        d4value
        d4status
        d4DeathStatus
        d4DeathTitle
        d4DeathFilePath
        d4DeathDescription
        wildNames
        wildDescription
        wildImage
        wildState
        status
        createdAt
        updatedAt
      }
      round
      createdAt
      updatedAt
    }
  }
`;
